import type { useSingleton } from "@tippyjs/react";
import { canv } from "@/canv/global";
import { ExportIcon } from "@/icons";
import { BottomBarItem } from "@/interface/BottomBar";
import { Tooltip } from "@/interface/ui/Tooltip";

type Props = {
    singletoneTarget: ReturnType<typeof useSingleton>[1];
    isActive: boolean;
    isDisabled: boolean;
};

export const ExportButton = ({ singletoneTarget, isActive, isDisabled }: Props) => {
    const openExportWindow = () => {
        // TODO: переделать на реакт
        canv.appInterface.exportWindow.open();
    };
    return (
        <Tooltip singleton={singletoneTarget} content="Экспорт">
            <BottomBarItem
                className="barPanelExport stroke"
                active={isActive}
                disabled={isDisabled}
                onClick={openExportWindow}
            >
                <ExportIcon />
            </BottomBarItem>
        </Tooltip>
    );
};
